
export default function Landing() {
    return (<p>Landing</p>);
};